<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation">
            <div>
              <AmountSelector />
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection title="Personal Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount/>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { form, submit, setValue } = usePaymentForm();

    const params = queryParams();

    if (params.designation) {
      //@ts-ignore
      switch (params.designation.toLowerCase()) {
        case "communalresearch":
          setValue("applications.0.department", "CommunalResearch");
          break;
        case "communityprojects":
          setValue("applications.0.department", "CommunityProjectsAndPartnerships");
          break;
        case "ifs":
          setValue("applications.0.department", "IsraelFreeSpirit");
          break;
        case "ncsy":
          setValue("applications.0.department", "NCSY");
          break;
        case "advocacy":
          setValue("applications.0.department", "Advocacy");
          break;
        case "relieffunds":
          setValue("applications.0.department", "ReliefFunds");
          break;
        case "ImpactAccelerator":
          setValue("applications.0.department", "ImpactAccelerator");
          break;
        case "ouisrael":
          setValue("applications.0.department", "OUIsrael");
          break;
        case "oupress":
          setValue("applications.0.department", "OUPress");
          break;
        case "jlic":
          setValue("applications.0.department", "JLIC");
          break;
        case "outorah":
          setValue("applications.0.department", "OU_Torah");
          break;
        case "synagogueinitiatives":
          setValue("applications.0.department", "SynagogueInitiatives");
          break;
        case "teachcoalition":
          setValue("applications.0.department", "TeachCoalition");
          break;
        case "yachad":
          setValue("applications.0.department", "Yachad");
          break;
        case "womensinitative":
          setValue("applications.0.department", "WomensInitative");
          break;
      }
    }

    return {
      form,
      submit,
      setValue
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
</style>
